import React from "react";
import ReactDOM from "react-dom";
import "./App.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import store from "./Redux/Store";
import { cleanHashFromUrl } from "./Utilities/RouterHelper";

// Clean hash fragments from Stripe redirects before rendering the app
if (window.location.search.includes("session_id=") && window.location.hash) {
  cleanHashFromUrl();
}

ReactDOM.render(
  <>
    <Provider store={store}>
      <App />
    </Provider>
  </>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
